export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Cash only at the restaurant. Card payment not accepted.',
  },
};
